import React, { useState, useEffect, useRef } from 'react'
import DataGrid from '../../../../components/DataGrid'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Alterar, AvisoSocioDocumento, Excluir, Visualizar } from '../../../../components/Acoes'
import { getApi, getUsuario } from '../../../../util/Configuracoes'
import { excluir } from '../../../../util/FuncoesComuns'
import { HeaderCadastro } from '../../../../components/Headers'
import { consultar, get, put, putComAcao } from '../../../../util/AcessoApi'
import { mensagens } from '../../../../util/Utilitarios'
import { mostrarToast } from '../../../../components/Toasts'
import { ACOES } from '../../../../util/Enums'

const ConsultaSocioTipoOcorrencia = (props) => {
    const [data, setData] = useState([])
    const target = useRef(null)
    const [objCarregar, setObjCarregar] = useState({ id: 0, carregando: false })

    useEffect(() => {
        consultar('/administracao/socio', (dados) => setData(dados))
    }, [])

    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-empresa',
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Descrição',
                        accessor: 'descricao',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Tipo Documento',
                        accessor: 'tipo_documento',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            tipo: 'tipo_documento_socio',
                            idColuna: 'socio_documento.tipo_documento_id',
                        }
                    },
                    {
                        Header: 'Data Atualização',
                        accessor: 'data_atualizacao',
                        ordenamento: {
                            tipo: 'data'
                        },
                    },

                    {
                        Header: 'Data Registro',
                        accessor: 'data_registro',
                        ordenamento: {
                            tipo: 'data'
                        },
                    },
                    {
                        Header: 'Data Atualização Inicial',
                        accessor: 'data_inicial',
                        visivel: false,
                        ordenamento: {
                            tipo: 'data'
                        },
                        filtro: {
                            tipo: 'data_inicial',
                            idColuna: 'data_atualizacao_inicial',
                            datePicker: true,
                            date: true

                        }
                    }, {
                        Header: 'Data Atualização Final',
                        accessor: 'data_final',
                        visivel: false,
                        ordenamento: {
                            tipo: 'data'
                        },
                        filtro: {
                            tipo: 'data_final',
                            idColuna: 'data_atualizacao_final',
                            datePicker: true,
                            date: true

                        }
                    },
                ],
            },
        ],
        []
    )

    const acoesObj = [
        (propsAcao) => <Visualizar to={'/administracao/socio-documento/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={'/administracao/socio-documento/alteracao/' + propsAcao.row.id} />,
        (propsAcao) => <Excluir to={'administracao/socio-documento/consulta/'} action={() => exclusao(propsAcao)} />,
        // (propsAcao) => <AvisoSocioDocumento to={'administracao/socio-documento/consulta/'} action={() => { setObjCarregar({ id: propsAcao.id, carregando: true }); enviarNotificacao(propsAcao) }} />,
        (propsAcao) => propsAcao.id === objCarregar.id && objCarregar.carregando ? <div className='icone ml-10 btn-acao'><span className=" spinner-border spinner-border-md" style={{ height: 20, width: 20, opacity: 0.2 }} role="status" aria-hidden="true"></span></div> : <AvisoSocioDocumento to={'administracao/socio-documento/consulta/'} action={() => { setObjCarregar({ id: propsAcao.id, carregando: true }); enviarNotificacao(propsAcao) }} />
    ]

    const exclusao = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: 172,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/administracao/sociodocumento', propsAcao.row.id,
                    () => {
                        // getApi(setData, '/faturamento/guia')
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        console.log('e: ', e);

                        mostrarToast('erro', mensagens.erro)
                    }, propsAcao.row.descricao_auditoria)
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const enviarNotificacao = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: 172,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)

                putComAcao(
                    ACOES.ENVIAR,
                    undefined,
                    propsAcao.row,
                    '/administracao/enviarNotificacaoSocio',
                    () => {
                        setObjCarregar({ id: 0, carregando: false })
                        mostrarToast('sucesso', mensagens.sucesso);

                    },
                    (erro) => {
                        mostrarToast('erro', mensagens.erro);
                    })
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    // const envioNotificacao = (propsAcao) => {


    //     // setEnviando(true);
    //     putComAcao(
    //         ACOES.ENVIAR,
    //         undefined,
    //         envio,
    //         '/administracao/enviarNotificacaoSocio',
    //         () => {
    //             target.current.atualizar();
    //             setObjCarregar({ id: 0, carregando: false })
    //             mostrarToast('sucesso', mensagens.sucesso);
    //             // setEnviar(false);
    //             // setEnviando(false);
    //             // setArrayEnvio([]);
    //             // setTimeout(() => {
    //             //     obterDados(filtros);
    //             // }, 200)
    //         },
    //         (erro) => {
    //             mostrarToast('erro', mensagens.erro);
    //             // setEnviando(false);
    //         })
    // }

    return (
        <>
            <div>
                <DataGridAlternativa
                    target={target}
                    data={data}
                    acoesObj={acoesObj}
                    columns={columns}
                    setData={setData}
                    caminhoBase='/administracao/sociodocumento'
                    caminhoConsultaFiltros='/administracao/sociodocumentopaginacao'
                    acoes={true}
                    url={{ cadastro: '/administracao/socio-documento/cadastro', }}
                    modulo={172}
                    titulo={'Consulta Sócio Documentos'}
                    urlCadastro='/administracao/socio-documento/cadastro'
                    icone={'icon-File-Cloud'} />
            </div>
        </>
    )
}

export default ConsultaSocioTipoOcorrencia